
//home 
if(document.getElementById('home')){
    var context = document.getElementById('reasonsWave').getContext('2d');
    var y1 = 1100;
    var y1limit = true;
    var y2 = 1300;
    var y2limit = true;
    var y3 = 900;
    var y3limit = true;
    var sectionimg = document.createElement('img');
    var circleposx = document.getElementById('reasonsWave').offsetWidth * 0.5;
    var circleposy = document.getElementById('reasonsWave').offsetHeight * 0.5;
}
//footer
var footerimg = document.createElement('img');
var ctxf = document.getElementById('footerWave').getContext('2d');
var fy1 = 280;
var fy2 = 0;
var fy1limit = false;
var fy2limit = true;

//amenities
if(document.getElementsByClassName('amenities-list').length > 0){
    var ay1 = 1000;
    var ay1limit = false;
    var ctxa = document.getElementById('amenitiesCanvas').getContext('2d');
    var maskImg = document.createElement('img');
}


(function(){
    document.addEventListener('DOMContentLoaded',function(){
        //if Explorer 11
	    if(!(window.ActiveXObject) && "ActiveXObject" in window){
            drawFooterEi();
        } else {
            if(document.getElementById('home')){
                circleposx = document.getElementById('reasonsWave').offsetWidth * 0.5;
                circleposy = document.getElementById('reasonsWave').offsetHeight * 0.5;
                sectionimg.onload=function(){
                    requestAnimationFrame(animate);
                };
                sectionimg.src = site_url + 'assets/svg/brand-bigcircle-bg.svg';
            }
            if(document.getElementById('amenitiesCanvas')){
                maskImg.onload=function(){
                    requestAnimationFrame(amenitiesA);
                };
                maskImg.src = site_url + 'assets/svg/brand-amenities-bg.svg';
            }
            //footer
            //drawFooter();
            
            if(!document.querySelector('.things-to-do-in-wisconsin.map')){
                footerimg.onload=function(){
                    requestAnimationFrame(animateF);
                };
            } else{
                footerimg.onload=function(){
                    drawFooter();
                };
            }
            footerimg.src = site_url + 'assets/svg/footer-leave.svg';

        }
       
    });

}());

//explorer draw footer
function drawFooterEi(){
    ctxf.clearRect(0, 0, 2200, 700); // clear canvas
    ctxf.save();
    ctxf.beginPath();
    ctxf.moveTo(0,100);
    ctxf.quadraticCurveTo(475,280,1100,130);
    ctxf.quadraticCurveTo(1525,0,2200,100);
    ctxf.lineTo(2200,700);
    ctxf.lineTo(0,700);
    ctxf.closePath();
    ctxf.fillStyle = "#082934";
    ctxf.fill();
    ctxf.clip();
    ctxf.drawImage(footerimg, 550,0,1500,1200);
    ctxf.restore();
    footerimg.src = site_url + 'assets/svg/footer-leave.svg';
}

//animation footer
function drawFooter(){
    ctxf.clearRect(0, 0, 2200, 700); // clear canvas
    ctxf.save();
    ctxf.beginPath();
    ctxf.moveTo(0,100);
    ctxf.quadraticCurveTo(475,fy1,1100,130);
    ctxf.quadraticCurveTo(1525,fy2,2200,100);
    ctxf.lineTo(2200,700);
    ctxf.lineTo(0,700);
    ctxf.closePath();
    ctxf.fillStyle = "#082934";
    ctxf.fill();
    ctxf.clip();
    ctxf.drawImage(footerimg, 550,0,1500,1200);
    ctxf.restore();
}

function animateF(time){

    if(fy1limit){
        fy1 = fy1 + 0.7;
        if(fy1 > 330){
            fy1limit = false;
        }
    } else {
        fy1 = fy1 - 0.7;
        if(fy1 < 100){
            fy1limit = true;
        }
    }
    if(fy2limit){
        fy2 = fy2 + 0.7;
        if(fy2 > 180){
            fy2limit = false;
        }
    } else {
        fy2 = fy2 - 0.7;
        if(fy2 < -50){
            fy2limit = true;
        }
    }

    requestAnimationFrame(animateF);
    drawFooter();
}

//amenities
function drawAmenities(){
    //let ctx = document.getElementById('amenitiesCanvas').getContext('2d');
    //let section = document.createElement('img');

        ctxa.clearRect(0, 0, 2200, 950); // clear canvas
        ctxa.save();
        ctxa.beginPath();
        ctxa.moveTo(0,230);
        ctxa.quadraticCurveTo(300,250,420,150);
        ctxa.quadraticCurveTo(650,-70,800,170);
        ctxa.quadraticCurveTo(950,400,1080,250);
        ctxa.quadraticCurveTo(1330,-25,1550,300);
        ctxa.quadraticCurveTo(1750,120,2200,350);
        ctxa.lineTo(2200,800);
        ctxa.quadraticCurveTo(1100,ay1,0,800);
        ctxa.closePath();
        ctxa.fillStyle = "#082934";
        ctxa.fill();
        ctxa.clip();
        ctxa.drawImage(maskImg,0,0);
        ctxa.restore();
        
  
    //section.src = site_url + 'assets/svg/brand-amenities-bg.svg';
}

//amenities
function amenitiesA(){
    if(ay1limit){
        ay1 = ay1 + 0.7;
        if(ay1 > 950){
            ay1limit = false;
        }
    } else {
        ay1 = ay1 - 0.7;
        if(ay1 < 780){
            ay1limit = true;
        }
    }
    requestAnimationFrame(amenitiesA);
    drawAmenities();
}


//home benefits canvas
function drawBenefits(){
    context.clearRect(0, 0, 2200, 1250); // clear canvas
    context.save();
    context.beginPath();
    context.moveTo(0, 525);
    context.quadraticCurveTo(170,380,530,480);
    context.bezierCurveTo(550,200,900,200,1050,510);
    context.quadraticCurveTo(1250,y3,1650,500);
    context.quadraticCurveTo(1800,0,2200,210);
    context.lineTo(2200,1200);
    context.quadraticCurveTo(1700,y1,1380,1200);
    context.quadraticCurveTo(1150,y2,800,1200);
    context.quadraticCurveTo(230,y1,0,1200);
    context.closePath();
    context.fillStyle = "#082934";
    context.fill();
    context.clip();
    context.drawImage(sectionimg,circleposx,circleposy);
    context.restore();
}

function animate(time){
    if(y1limit){
        y1 = y1 + 0.7;
        if(y1 > 1300){
            y1limit = false;
        }
    } else {
        y1 = y1 - 0.7;
        if(y1 < 1100){
            y1limit = true;
        }
    }

    if(y2limit){
        y2 = y2 - 0.7;
        if(y2 < 1100){
            y2limit = false;
        }
    } else {
        y2 = y2 + 0.7;
        if(y2 > 1300){
            y2limit = true;
        }
    }

    if(y3limit){
        y3 = y3 + 0.7;
        if(y3 > 1000){
            y3limit = false;
        }
    } else {
        y3 = y3 - 0.7;
        if(y3 < 850){
            y3limit = true;
        }
    }
    requestAnimationFrame(animate);
    drawBenefits();
}